import { toast } from '@utils/functions/notificationToast'

import { useLayout } from '.'

import type { AxiosError } from 'axios'

import * as apiLayout from '@services/api/layout'

const getSideBarData = async () => {
  const { setSideBarData, setIsSideBarDataLoading } = useLayout.getState()

  setIsSideBarDataLoading(true)

  try {
    const data = await apiLayout.getSideBarData()

    setSideBarData(data)
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao obter os dados do menu!'

    toast.error(errorMessage, (error as AxiosError)?.status)
  } finally {
    setIsSideBarDataLoading(false)
  }
}

export { getSideBarData }
